var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 14.7499H3.75C3.55109 14.7499 3.36032 14.6709 3.21967 14.5303C3.07902 14.3896 3 14.1989 3 13.9999V7.24994H0.75L8.49525 0.20894C8.63333 0.0832983 8.81331 0.0136719 9 0.0136719C9.18669 0.0136719 9.36667 0.0832983 9.50475 0.20894L17.25 7.24994H15V13.9999C15 14.1989 14.921 14.3896 14.7803 14.5303C14.6397 14.6709 14.4489 14.7499 14.25 14.7499ZM9.75 13.2499H13.5V5.86769L9 1.77719L4.5 5.86769V13.2499H8.25V8.74994H9.75V13.2499Z",
    fill: "#020306"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.bbf38d0e4b1d54ae0ce458ecc9d622d7.svg";
export { ForwardRef as ReactComponent };